__turbopack_context__.v({
  "input": "selectDark-module___0cN7G__input",
  "is-selected": "selectDark-module___0cN7G__is-selected",
  "option": "selectDark-module___0cN7G__option",
  "options": "selectDark-module___0cN7G__options",
  "row": "selectDark-module___0cN7G__row",
  "select": "selectDark-module___0cN7G__select",
});
